export default __webpack_public_path__ + "questionnaire-iconaa435c.png";